var device = {};
var ua = navigator.userAgent;

var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);

var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);

device.os = 'other';
device.ios = device.android = device.iphone = device.ipad = device.androidChrome = false;

// Android
if (android) {
  device.os = 'android';
  device.osVersion = android[2];
  device.android = true;
  device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
}
if (ipad || iphone || ipod) {
  device.os = 'ios';
  device.ios = true;
}
// iOS
if (iphone && !ipod) {
  device.osVersion = iphone[2].replace(/_/g, '.');
  device.iphone = true;
}
if (ipad) {
  device.osVersion = ipad[2].replace(/_/g, '.');
  device.ipad = true;
}
if (ipod) {
  device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
  device.iphone = true;
}

// iOS 8+ changed UA
if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
  if (device.osVersion.split('.')[0] === '10') {
    device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
  }
}

// Webview
device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);

var classNames = [], major, i;
// Pixel Ratio
device.pixelRatio = window.devicePixelRatio || 1;
classNames.push(`pixel-ratio-${Math.floor(device.pixelRatio)}`);
if (device.pixelRatio >= 2) {
  classNames.push('retina');
}

// OS classes
if (device.os) {
  classNames.push(device.os, `${device.os}-${device.osVersion ? device.osVersion.split('.')[0] : ''}`, `${device.os}-${device.osVersion ? device.osVersion.replace(/\./g, '-') : ''}`);
  if (device.os === 'ios') {
    major = parseInt(device.osVersion.split('.')[0], 10);
    for (i = major - 1; i >= 6; i--) {
      classNames.push(`ios-gt-${i}`);
    }
  }
}
device.isWeixin = /MicroMessenger/i.test(ua);
device.isMininWx = /miniProgram/i.test(ua);
device.isAlipay = /Alipay/i.test(ua);

var channel = '';
if (device.isWeixin) {
  if (device.isMininWx) {
    channel = 'mini_wx_app'
  } else {
    channel = 'wx'
  }
}else if (device.isAlipay) {
  channel = "alipay";
} else {
  channel = 'other'
}
device.channel = channel;

device.classNames = classNames;

export default device;
